import {buildField} from '@eitje/form'
import {Switch} from '~/components'
import * as React from 'react'
import _ from 'lodash'

export const SwitchField = React.memo(
	buildField(Switch, {className: 'switch-field', clearIcon: false, inputPosition: 'right', autoFocus: false}),
	_.isEqual,
)
